import { useMemo } from "react";
import styles from "./MikeTitleParameters.module.less";
import { Typography } from "antd";
import {
  CampaignCreatedParameterModel,
  CopilotResponseActionType,
  HealtProcessSummaryResponseParameters,
  MikeMessageParameters,
  MikeMessageTitle,
  ThermalLiDARResponseParameters,
} from "~/pages/copilotMessage/types/copilot";
import { isConversationGeneric } from "~/pages/copilotMessage/components/conversationDetail/components/conversationMessages/components/mikeMessage/helpers/mikeMessageParametersHelper";

interface MikeTitleParametersProps {
  type: CopilotResponseActionType;
  parameters?: MikeMessageParameters;
  conversationId: string;
}

function MikeTitleParameters({
  type,
  parameters,
  conversationId,
}: MikeTitleParametersProps) {
  const hasParameters = useMemo(() => {
    return parameters !== undefined;
  }, [parameters]);

  // Check if this is a generic conversation
  const isGeneric = isConversationGeneric(conversationId);

  const campaignStartParams = useMemo(() => {
    return (parameters ?? {}) as CampaignCreatedParameterModel;
  }, [parameters]);

  const paramsWithHeat = useMemo(() => {
    const resParams = (parameters ?? {}) as
      | ThermalLiDARResponseParameters
      | HealtProcessSummaryResponseParameters;

    return (
      type === CopilotResponseActionType.LaserScan
        ? resParams.LiDARData
        : type === CopilotResponseActionType.ThermalScan
          ? resParams.ProcessedHeatThermalData
          : resParams.CampaignHeat || {}
    ) as MikeMessageTitle;
  }, [parameters, type]);

  return (
    <div className={`${styles.MikeTitleParameters}`}>
      {/* Only show separator if there are parameters to display */}
      {hasParameters &&
        (type === CopilotResponseActionType.CampaignCreated ||
          (!isGeneric && paramsWithHeat.HeatNumber !== undefined)) && (
          <Typography.Text className={styles.line}>-</Typography.Text>
        )}

      {type === CopilotResponseActionType.CampaignCreated && (
        <>
          <Typography.Title level={2} className={styles.label}>
            Campaign
          </Typography.Title>

          <Typography.Title level={2} className={styles.value}>
            {campaignStartParams.CampaignName}
          </Typography.Title>
        </>
      )}

      {/* Hide heat number and campaign information for generic conversations */}
      {!isGeneric && paramsWithHeat.HeatNumber !== undefined && (
        <>
          <Typography.Title level={2} className={styles.value}>
            {`Heat ${paramsWithHeat.HeatNumber}`}
          </Typography.Title>

          <Typography.Title
            level={2}
            className={`${styles.value} ${styles.thin}`}
          >
            {` (${paramsWithHeat.HeatName})`}
          </Typography.Title>

          <Typography.Title level={2} className={styles.campaignTitle}>
            Campaign
          </Typography.Title>
          <Typography.Title level={2} className={styles.line}>
            {paramsWithHeat.CampaignName}
          </Typography.Title>
        </>
      )}
    </div>
  );
}

export default MikeTitleParameters;
